import { TFunction } from "i18next";
import * as Yup from "yup";

import { TemplateLabels, TemplateSubjectConfig } from "./TemplateManagement.types";

export function templateValidationSchema(
  t: TFunction,
  labels: TemplateLabels,
  titleMaxLength: number,
  subject?: TemplateSubjectConfig
) {
  return Yup.object().shape({
    title: Yup.string()
      .required(t("common.validation.fieldRequired", { fieldName: labels.title }))
      .max(titleMaxLength, t("common.validation.maxLength", { max: titleMaxLength })),
    content: Yup.string().required(t("common.validation.fieldRequired", { fieldName: labels.content })),
    subject: subject
      ? Yup.string()
          .required(t("common.validation.fieldRequired", { fieldName: subject.label }))
          .max(subject.maxLength, t("common.validation.maxLength", { max: subject.maxLength }))
      : Yup.string(),
  });
}
